import { PayFrequencyOptionLabel, PayFrequencyOptionValue } from 'handlers/yourTotalIncome';
import { InputSelectOption } from 'components/InputSelect/InputSelect';

export enum YourEmployerInputLabel {
  EmployerName = 'Employer name',
  HireDate = 'Start of employment',
  JobTitle = 'Your job title',
  AnnualIncome = 'Gross annual income',
  PayFrequency = 'Pay Frequency',
  AdditionalIncome = 'Additional income',
  IsLicensedProfessional = 'I am a licensed healthcare professional',
  HealthcareLicenseNumber = 'Healthcare license number',
  HealthcareLicenseState = 'Healthcare license state',
}

export const PAY_FREQUENCY_OPTIONS = [
  { label: PayFrequencyOptionLabel.Weekly, value: PayFrequencyOptionValue.Weekly },
  { label: PayFrequencyOptionLabel.BiWeekly, value: PayFrequencyOptionValue.BiWeekly },
  { label: PayFrequencyOptionLabel.SemiMonthly, value: PayFrequencyOptionValue.SemiMonthly },
  { label: PayFrequencyOptionLabel.Monthly, value: PayFrequencyOptionValue.Monthly },
] as InputSelectOption[];

export const ANNUAL_INCOME_MAX_LENGTH = 14;
export const MONETARY_PREFIX = '$';
